/**
 * The aggregated person (03), keyed by handle AND the list the panel is open
 * over: `import_id` changes the answer (`is_current_list`, `current_list`), so
 * the standalone page and each list hold their own entry.
 *
 * `personQueryKey(handle)` is the PREFIX every entry for one person shares.
 * After an action on the person the page invalidates it together with the
 * contacts table's key, so the table row and the panel refetch from the same
 * write (PRD failure case "stale action state").
 */
import { skipToken, useQuery } from "@tanstack/react-query";

import type { PeopleClient } from "../../clients/people.client";

export function personQueryKey(handle: string): readonly unknown[] {
  return ["person", handle];
}

export function usePerson(client: PeopleClient, handle: string | null, importId?: string | null) {
  return useQuery({
    queryKey: [...personQueryKey(handle ?? ""), importId ?? null],
    // The signal lets TanStack abort a read nobody is waiting for any more:
    // holding → walks past people whose GET is still in flight.
    queryFn: handle ? ({ signal }) => client.getPerson(handle, importId, { signal }) : skipToken,
    // A 404 (no list has this person) is an answer, not a blip to retry.
    retry: false,
  });
}
